export default __webpack_public_path__ + "static/media/b65.9fe77a27.png";